import { Link } from "react-router-dom";
import { videos, categories } from "@/mocks/videoData";

export default function LatestSection() {
  const latestVideos = videos.slice(0, 8);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新上线
            </h2>
            <p className="text-sm text-foreground-600 mt-1">每日更新，第一时间为你呈现精彩内容</p>
          </div>
          <Link
            to="/category/movie"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            全部新片 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  title={`${video.title} - 苹果视频免费在线观看`}
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded font-medium">
                    {getCategoryName(video.category)}
                  </span>
                </div>
                <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/20 transition-colors flex items-center justify-center">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-lg"></i>
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-xs text-foreground-500">{video.year}</span>
                  <span className="text-xs text-amber-500 font-medium flex items-center gap-0.5">
                    <i className="ri-star-fill text-[10px]"></i>
                    {video.rating}
                  </span>
                  <span className="text-xs text-foreground-500">{video.duration}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}